package games.polyclub.website.frontend.store

import games.polyclub.tool.endpoint.Endpoint
import games.polyclub.tool.endpoint.EndpointInvoker
import games.polyclub.tool.functional.retrying
import io.ktor.client.request.*
import io.ktor.http.*
import kotlinx.coroutines.Deferred
import kotlinx.coroutines.async
import kotlinx.coroutines.withTimeout
import web.dom.document
import kotlin.time.Duration.Companion.seconds

private suspend fun loadEndpointUrl(): Url {
    try {
        val url = Url(withTimeout(3.seconds) {
            Endpoint(URLBuilder(document.URL).appendPathSegments("bff.url").build())
                .createInvoker()
                .get<String>()
        })
        return url
    } catch (e: Exception) {
        console.error("Erro ao carregar o URL do BFF: ", e)
        throw e
    }
}

internal val storeBff: Deferred<EndpointInvoker> = appScope.async {
    val result = retrying(delay = 1.seconds) {
        loadEndpointUrl()
    }
    Endpoint(result).createInvoker {
        StoreBff.token?.let { token ->
            bearerAuth(token)
        }
    }
}
